import { createUseStyles } from '@glu/theming';

/* istanbul ignore next */
const styles = ({ spacing: { unit }, typography: { fontWeightHeavy } }) => ({
  timeRemaining: {
    marginBottom: unit * 2.25,
    marginTop: unit * 3.25
  },
  countDownLabel: {
    fontWeight: fontWeightHeavy,
    fontSize: unit * 2,
    color: '#4c4c4c'
  },
  countDown: {
    color: '#df0000',
    fontWeight: fontWeightHeavy,
    fontSize: unit * 2.25,
    marginLeft: unit * 0.625
  },
  actionBtns: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: unit * 1.875
  },
  resumeBtn: {
    marginRight: unit * 2.0,
    textTransform: 'uppercase',
    padding: '12px 50px',
    fontWeight: 900
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  instructions: {
    fontSize: unit * 1.75,
    lineHeight: '24px'
  },
  centerPopupWindow: {
    left: 5,
    margin: '0 auto',
    width: '100%',
    height: '100%'
  }
});

export const useStyles = createUseStyles(styles);
export default styles;
